import {
    ViewEncapsulation,
    Component,
    HostBinding,
    ElementRef,
    inject,
    input,
    ChangeDetectionStrategy,
    OnInit,
} from '@angular/core';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host {  --margin-bottom: initial; --margin-bottom-major: var(--margin-bottom); --line-height: inherit; --line-height-major: var(--line-height); --font-size: inherit; --font-size-major: var(--font-size); --color: initial; --color-major: var(--color); display: block; font-size: var(--font-size); font-weight: 500; line-height: var(--line-height); color: var(--color); } .bazis-label__native { display: block; margin-bottom: var(--margin-bottom); } :host(.bazis-label_major) { font-weight: 700; font-size: var(--font-size-major); color: var(--color-major); } :host(.bazis-label_major) .bazis-label__native { margin-bottom: var(--margin-bottom-major); } :host(.bazis-label_inner) { padding-left: var(--padding-field-start); font-size: inherit; font-weight: 400; } :host(.bazis-label_inner) + .bazis-control__field { padding-left: 0; } :host(.bazis-label_inner) .bazis-label__native { margin-bottom: 0; } .bazis-label__required { color: var(--bazis-color-danger); } ::slotted(bazis-interrogation[slot=labelStart]) { margin-left: 0; margin-right: var(--bazis-margin-3x); display: inline-flex; } ::slotted(bazis-interrogation[slot=labelEnd]) { margin-left: var(--bazis-margin-1x); }`,
);

@Component({
    selector: 'bazis-label',
    templateUrl: './label.component.html',
    // styleUrls: ['label.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LabelElement implements OnInit {
    public el = inject(ElementRef);

    readonly isEmptyLabel = input<boolean>(false);

    readonly isMajor = input<boolean>(false);

    readonly required = input<boolean>();

    readonly isInner = input<boolean>();

    readonly title = input<string>(null);

    @HostBinding('class') get labelStyle() {
        return {
            'bazis-label': true,
            'bazis-label_major': !!this.isMajor(),
            'bazis-label_inner': !!this.isInner(),
        };
    }

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
